export default {
    GET_CART_ITEMS: "GET_CART_ITEMS",
    GET_CART_ITEMS_SUCCESS: "GET_CART_ITEMS_SUCCESS",

    GET_RELATIVE: "GET_RELATIVES",
    GET_RELATIVE_SUCCESS: "GET_RELATIVE_SUCCESS",



    ADD_CART: "ADD_CART",
    ADD_CART_SUCCESS: "ADD_CART_SUCCESS",

    // GET_DELIVERY_ADDRESS: "GET_DELIVERY_ADDRESS",
    // GET_DELIVERY_ADDRESS_SUCCESS: "GET_DELIVERY_ADDRESS_SUCCESS",

    CLEAR_CART: "CLEAR_CART",

    SELECTED_ADDRESS: "SELECTED_ADDRESS",


}